






















































































































































































import Vue from "vue";
import { Studio } from "../api/Studio";
import {
  fruehesterTermin,
  formatTime as _formatTime,
  DAY_FORMAT,
  WOCHENTAGE,
  Dame,
  DienstplanEintrag,
  currentTimestamp,
  sortDamenAlnum,
  sortStringsAlnum,
} from "../api/Termine";
import { default as moment, Moment } from "moment";
import { forkJoin } from "rxjs";
import {
  DienstUpdateEvent,
  default as DienstplanPopover,
} from "./DienstplanPopover.vue";

/*-
import DienstplanPopover, {
  DienstplanUpdateEvent,
} from "./DienstplanPopover.vue";
*/
type Modus = "Auswahl" | "Bearbeitung";
interface Kalenderwoche {
  von: string;
  bis: string;
  kw: string;
  wochenstart: string;
  label: string;
}
interface DienstplanReihe {
  dame: Dame;
  dienste: DienstplanEintrag[];
}

export default Vue.extend({
  name: "Dienstplan",
  components: {
    DienstplanPopover,
  },
  data: () => {
    return {
      tage: [] as string[],
      studio: {} as Studio,
      studios: [] as Studio[],
      vergangeneKalenderwochenAnzeigen: false,
      kalenderwochen: [] as Kalenderwoche[],
      kalenderwoche: {} as Kalenderwoche,
      modus: "Auswahl" as Modus,
      verfuegbareDamen: [] as Dame[],
      auswaehlbareDamen: [] as Dame[],
      dienstplan: [] as DienstplanReihe[],
    };
  },
  mounted() {
    const setStudios = (studios: Studio[]) => {
      this.studios = studios.filter((studio) =>
        this.$znaApi.darfDienstplanVonStudioLesen(studio.bezeichner)
      );
      if (this.studios.length == 1) {
        this.studio = this.studios[0];
      }
    };

    const studios: Studio[] = this.$store.getters["studios"];
    if (Array.isArray(studios) && studios.length) {
      setStudios(studios);
    } else {
      this.$znaApi.getStudios().subscribe(setStudios, console.error);
    }

    const studio: Studio = this.$store.getters["gewaehltesStudio"];
    if (studio && studio.id) {
      this.studio = studio;
    }

    this.updateKalenderwochen();
  },
  computed: {
    buttonDisabled() {
      return !this.kalenderwoche || !this.studio || !this.studio.id;
    },
    buttonLabel() {
      if (
        (!this.kalenderwoche || !this.kalenderwoche.kw) &&
        (!this.studio || !this.studio.id)
      ) {
        return "Studio und KW auswählen";
      } else if (
        this.kalenderwoche &&
        this.kalenderwoche.kw &&
        this.studio &&
        this.studio.id
      ) {
        const verb = this.$znaApi.darfDienstplanVonStudioSchreiben(this.studio.bezeichner) ? 'bearbeiten' : 'einsehen';
        return `Dienstplan für KW ${this.kalenderwoche.kw} in ${this.studio.name} ${verb}`;
      } else if (this.studio && this.studio.id) {
        return `Dienstplan für KW ??? in ${this.studio.name} öffnen`;
      } else {
        return `Dienstplan für KW ${this.kalenderwoche.kw} in Studio <auswählen> öffnen`;
      }
    },
  },
  methods: {
    darfDienstplanVonStudioSchreiben(studio: Studio) {
      return this.$znaApi.darfDienstplanVonStudioSchreiben(studio.bezeichner);
    },
    updateKalenderwochen() {
      let numWeeks = 10;
      const wochen: Kalenderwoche[] = [];
      const tempWeekStart = currentTimestamp().startOf('isoWeek').hour(12);
      let kwIndex = 0;
      if (this.vergangeneKalenderwochenAnzeigen) {
        tempWeekStart.subtract(10, 'weeks');
        numWeeks += 10;
        kwIndex = 10;
      }
      for (let i = 0; i < numWeeks; i++) {
        wochen.push(this.createKwButton(tempWeekStart));
        tempWeekStart.add(1, 'week');
      }
      this.kalenderwochen = wochen;
      if (!this.kalenderwoche.kw) {
        this.kalenderwoche = wochen[kwIndex];
      }
    },
    createKwButton(kwStart: Moment): Kalenderwoche {
      const kw = kwStart.isoWeek();
      const von = kwStart.format(DAY_FORMAT);
      const bis = kwStart
        .clone()
        .add(6, 'days')
        .format(DAY_FORMAT);
      return {
        kw: `${kw}`,
        von,
        bis,
        wochenstart: kwStart.format(),
        label: `KW ${kw} <br/> (${von} bis ${bis})`,
      };
    },
    setWeek(offset: number) {
      if (offset < 0) {
        const prevWochenstart = moment(this.kalenderwoche.wochenstart).subtract(
          1,
          "week"
        );
        let prevWochenIndex = -1;
        for (let i = 0; i < this.kalenderwochen.length; i++) {
          if (
            this.kalenderwochen[i].wochenstart.localeCompare(
              prevWochenstart.format()
            ) > 0
          ) {
            break;
          }
          prevWochenIndex = i;
        }
        if (prevWochenIndex >= 0) {
          this.kalenderwoche = this.kalenderwochen[prevWochenIndex];
          this.edit();
          return;
        }
        this.kalenderwoche = this.createKwButton(prevWochenstart);
        this.kalenderwochen.splice(0, 0, this.kalenderwoche);
        this.edit();
      } else if (offset > 0) {
        const nextWochenstart = moment(this.kalenderwoche.wochenstart).add(
          1,
          "week"
        );
        let nextWochenIndex = this.kalenderwochen.length;
        for (let i = this.kalenderwochen.length - 1; i >= 0; i--) {
          if (
            this.kalenderwochen[i].wochenstart.localeCompare(
              nextWochenstart.format()
            ) < 0
          ) {
            break;
          }
          nextWochenIndex = i;
        }
        if (
          nextWochenIndex >= 0 &&
          nextWochenIndex < this.kalenderwochen.length
        ) {
          this.kalenderwoche = this.kalenderwochen[nextWochenIndex];
          this.edit();
          return;
        }
        this.kalenderwoche = this.createKwButton(nextWochenstart);
        this.kalenderwochen.push(this.kalenderwoche);
        this.edit();
      }
    },
    formatTime(zeit: string, minute = "00"): string {
      return _formatTime(zeit, minute);
    },
    auswahl() {
      this.modus = "Auswahl";
    },
    edit() {
      const tag = moment(this.kalenderwoche.von, DAY_FORMAT);
      const max = moment(this.kalenderwoche.bis, DAY_FORMAT).add(1, "day");

      this.modus = "Bearbeitung";

      this.tage = [];
      for (; tag.isBefore(max); tag.add(1, "day")) {
        this.tage.push(`${WOCHENTAGE[tag.isoWeekday()-1]}, ${tag.format("DD.MM.")}`);
      }
      console.log(this.tage);
      this.update();
    },
    searchDame(event: { originalEvent: any; query: string }) {
      console.log("Suchanfrage: " + event.query);
      const damen: Dame[] = [];
      const gebuchteDamen: { [id: string]: boolean } = {};
      this.dienstplan.forEach((dienstplanReihe) => {
        gebuchteDamen["" + (dienstplanReihe.dame.id || -1)] = true;
      });
      this.verfuegbareDamen.forEach((dame) => {
        if (!gebuchteDamen["" + dame.id]) {
          damen.push(dame);
        }
      });
      if (event.query && event.query.length) {
        this.auswaehlbareDamen = damen.filter(
          (dame) => dame.kuenstlername.toLowerCase().indexOf(event.query) >= 0
        );
      } else {
        this.auswaehlbareDamen = damen;
      }
    },
    neueDameSelected(data: { originalEvent?: any; value: Dame }) {
      const tag = moment(this.kalenderwoche.von, DAY_FORMAT)
        .hour(fruehesterTermin | 0)
        .minute((fruehesterTermin - (fruehesterTermin | 0)) * 60);
      this.dienstplan.push({
        dame: data.value,
        dienste: [
          { von: tag.format() } as DienstplanEintrag,
          { von: tag.add(1, "day").format() } as DienstplanEintrag,
          { von: tag.add(1, "day").format() } as DienstplanEintrag,
          { von: tag.add(1, "day").format() } as DienstplanEintrag,
          { von: tag.add(1, "day").format() } as DienstplanEintrag,
          { von: tag.add(1, "day").format() } as DienstplanEintrag,
          { von: tag.add(1, "day").format() } as DienstplanEintrag,
        ],
      });
    },
    dameAngelegt(dame: Dame) {
      this.verfuegbareDamen.push(dame);
      this.verfuegbareDamen.sort(sortDamenAlnum);
      this.neueDameSelected({ value: dame });
    },
    editDienst(event: any, dame: Dame, dienst?: DienstplanEintrag) {
      if (!this.darfDienstplanVonStudioSchreiben(this.studio)) {
        window.alert(`Sie benötigen Schreibzugriff für ${this.studio.name}`)
        return;
      }
      const popover: any = this.$refs.popover;
      this.$nextTick(() =>
        popover.show(dienst && dienst.id ? "edit" : "create", dame, dienst)
      );
    },
    eintragUpdated(update: DienstUpdateEvent) {
      update.eintrag.studio = this.studio;
      switch (update.popoverMode) {
        case "create":
        case "edit":
          this.$znaApi
            .dienstSpeichern(update.eintrag)
            .subscribe(() => this.update());
          break;
        case "delete":
          this.$znaApi
            .dienstLoeschen(update.eintrag)
            .subscribe(() => this.update());
          break;
        default:
          this.$toast.add({
            severity: "error",
            summary: "Fehler",
            detail: `Aktualisierungmodus "${update.popoverMode}" für Dienstplan nicht unterstützt`,
            life: 3000,
          });
      }
    },
    update() {
      this.$store.dispatch("appLoading", true);

      const tag = moment(this.kalenderwoche.von, DAY_FORMAT);

      const setDamenUndDienste = ((
        verfuegbareDamen: Dame[],
        dienstplan: DienstplanReihe[]
      ) => {
        this.verfuegbareDamen = verfuegbareDamen;
        this.dienstplan = dienstplan;
      }).bind(this);

      forkJoin(
        this.$znaApi.getVerfuegbareDamen(this.studio),
        this.$znaApi.getDienstplanKw(this.studio, tag)
      ).subscribe(
        ([verfuegbareDamen, dienstplan]) => {
          const beschaeftigteDamen: { [name: string]: Dame } = {};
          const reihen: { [name: string]: DienstplanReihe } = {};
          dienstplan.forEach((dienst) => {
            if (dienst.dame) {
              beschaeftigteDamen[dienst.dame.kuenstlername] = dienst.dame;
              if (!reihen[dienst.dame.kuenstlername]) {
                const datum = moment(this.kalenderwoche.von, DAY_FORMAT)
                  .hour(fruehesterTermin | 0)
                  .minute((fruehesterTermin - (fruehesterTermin | 0)) * 60);
                reihen[dienst.dame.kuenstlername] = {
                  dame: dienst.dame,
                  dienste: [
                    { von: datum.format() } as DienstplanEintrag,
                    { von: datum.add(1, "day").format() } as DienstplanEintrag,
                    { von: datum.add(1, "day").format() } as DienstplanEintrag,
                    { von: datum.add(1, "day").format() } as DienstplanEintrag,
                    { von: datum.add(1, "day").format() } as DienstplanEintrag,
                    { von: datum.add(1, "day").format() } as DienstplanEintrag,
                    { von: datum.add(1, "day").format() } as DienstplanEintrag,
                  ],
                };
              }
              const weekdayIndex = moment(dienst.von).isoWeekday()-1;
              reihen[dienst.dame.kuenstlername].dienste[weekdayIndex] = dienst;
            }
          });
          setDamenUndDienste(
            verfuegbareDamen
              .filter((dame) => !beschaeftigteDamen[dame.kuenstlername])
              .sort(sortDamenAlnum),
            Object.keys(reihen)
              .map((kuenstlername) => reihen[kuenstlername])
              .sort((reihe1, reihe2) => sortDamenAlnum(reihe1.dame, reihe2.dame))
          );
          this.$store.dispatch("appLoading", false);
        },
        (error) => {
          this.$toast.add({
            severity: "error",
            summary: "Laden der Daten fehlgeschlagen",
            detail: error,
            life: 3000,
          });
          this.$store.dispatch("appLoading", false);
        }
      );
    },
  },
});
